import { Component, ChangeDetectionStrategy, Optional, Inject, OnInit } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'no-kno-confirm-dialog',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmDialogComponent {

  constructor(
    public dialog: MatDialog,
    @Optional() private reference: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; text?: string; closeLabel?: string; acceptLabel?: string; hideAccept?: boolean}
  ) { }

  onClose(value: boolean) {
    this.reference.close(value);
  }
}
